/* eslint-disable @nx/enforce-module-boundaries */
import { VisibilityIcon } from '@mybridge/icons';
import {
  Box,
  Button,
  Editable,
  EditableInput,
  EditablePreview,
  FormControl,
  FormErrorMessage,
  HStack,
  Heading,
  Input,
  InputGroup,
  InputRightElement,
  Link,
  Spinner,
  Stack,
  Switch,
  Text,
  Card,
  CardBody,
  VStack,
} from '@mybridge/ui';
import { forwardRef, useContext, useEffect, useRef, useState } from 'react';
import { MyProfileContext } from '../context';
import { getDomainName } from 'v4/lib/commons';
import { Controller, useForm } from 'react-hook-form';
import { getUserSlug } from 'v4/store/actions/user-profile.actions';
import {
  useDisclosure,
  useEditableControls,
  useOutsideClick,
} from '@mybridge/ui/hooks';
import { LinkIcon } from '@mybridge/icons/Link';
import { useDispatch } from 'react-redux';
import SectionLoader from 'v4/components/common/loader/sectionLoader';
import { useTranslator } from '@mybridge/ui/custom-hooks/useTranslation';
import { useDirection } from '@mybridge/ui/custom-hooks/useDirection';

export const MyProfileLink = forwardRef(({ ...props }, ref) => {
  const [host, setHost] = useState();
  const [origin, setOrigin] = useState('');
  const dispatch = useDispatch();
  const editDisc = useDisclosure();
  const { t } = useTranslator();
  const direction = useDirection();
  const inputRef = useRef();
  const [toggleInput, setToggle] = useState(false);
  const [validState, setValidState] = useState();
  const [newUrlPart, setNewUrlPart] = useState();
  
  useOutsideClick({
    ref: inputRef,
    handler() {
      editDisc?.onClose();
      clearErrors?.();
    },
  });

  const { userProfileInfo, updateProfile, profileUpdateLoading } =
    useContext(MyProfileContext);

  const { is_visible, slug } = userProfileInfo ?? {};

  const {
    register,
    handleSubmit,
    control,
    formState: { errors },
    setError,
    clearErrors,
  } = useForm({ values: { slug } });

  useEffect(() => {
    setHost(getDomainName());
    // Set origin only on client side
    if (typeof window !== 'undefined') {
      setOrigin(window.location.origin);
    }
  }, []);

  const onUpdate = async (form) => {
    const done = await updateProfile({ slug: form });
    if (done) {
      editDisc?.onClose();
      setToggle(!toggleInput);
    } else {
      setError('slug', { message: 'Please provide a valid slug' });
    }
  };

  const handleCheckSlug = (e) => {
    if (e.target.value.length > 5) {
    dispatch(getUserSlug(e.target.value)).then((res) => {
      // console.log(typeof res?.payload?.is_available);
      if (res?.is_available === 'true') {
        setValidState(false);
      } else {
        setValidState(true);
        setNewUrlPart(e.target.value);
      }
    });
    }
  };

  return (
    <>
      <HStack flexDir={['column', 'column', 'row']} alignItems="center">
        <LinkIcon width={20} height={20} color="#3D5A80" />
        <Heading fontSize="18px" fontWeight="400" color="#3D5A80">
          {t('profile.editCustomURL') || "Edit custom URL"}
        </Heading>
      </HStack>
      <Text fontSize="14px" color="#5B5B5B" fontWeight={400} pt={3}>
        {t('profile.personalizeProfileURL') || "Personalize your profile's public URL"}
      </Text>
      {/* {profileUpdateLoading ? (
        <></>
      ) : ( */}
        <Link fontSize="sm" color="gray.700" fontWeight="medium">
          <HStack
            // flexDir={['column', 'column', 'row']}
            pt={2}
            alignItems="flex-start"
            gap="0"
            display='flex'
            sx={{direction: 'ltr'}} 
            {...(direction === 'rtl' && {justifyContent: 'flex-end'})}
          >
            <Text fontSize="12px" fontWeight="400" color="#5B5B5B"  mt={'2.7px'}>
              {/* www.mybridge.me/p/ */}
              {origin}/p/
            </Text>
            {!toggleInput ? (
              <Text
                textDecoration="underline"
                onClick={() => setToggle(!toggleInput)}
              >
                {slug}
              </Text>
            ) : (
              <VStack>
                <Input
                  onChange={(e) => handleCheckSlug(e)}
                  // onKeyDown={(e) => handleCheckSlug(e)}
                  focusBorderColor="brandGrey.200"
                  // onBlur={(e) => handleCheckSlug(e)}
                  defaultValue={slug}
                  height="30px"
                  width="100%"
                  p={1}
                  mt="-5px"
                  border="1px solid"
                  borderColor={validState ? 'brandGreen.500' : 'brandRed.500'}
                />
                <HStack w="100%" justifyContent="flex-end">
                  <Button
                    size="sm"
                    borderRadius="full"
                    variant="secondary"
                    onClick={() => setToggle(!toggleInput)}
                  >
                    {t('buttons.cancel') || "Cancel"}
                  </Button>
                  <Button
                    size="sm"
                    borderRadius="full"
                    variant="primary"
                    onClick={() => onUpdate(newUrlPart)}
                    isDisabled={validState ? false : true}
                  >
                    {t('buttons.save') || "Save"}
                  </Button>
                </HStack>
              </VStack>
            )}
          </HStack>
        </Link>
      {/* )} */}
    </>
  );
});
